import { render } from "./FashionistItem.vue?vue&type=template&id=10dbeba2"
import script from "./FashionistItem.vue?vue&type=script&lang=js"
export * from "./FashionistItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__